import { Suspense } from "react";
import { redirect, useRoutes } from "react-router-dom";
import { useAuth } from "provider/AuthContext";
import PrivateRoutes from "./routes/PrivateRoute";
import PublicRoutes from "./routes/PublicRoutes";
import AppLoader from "./components/ui/loaders/AppLoader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "assets/css/styles.min.css";
import "config/i18n";

function App() {
  const { user } = useAuth();
  const isAuthenticated = !!user;
  const checkAuth = () => {
    if (isAuthenticated) {
      if (user?.role !== "User") {
        return redirect(`/admin/transfer`);
      } else {
        return redirect("/");
      }
    }
  };

  const routes = useRoutes([checkAuth() ? PrivateRoutes() : [], ...PublicRoutes()]);

  return (
    <div className="app-wrapper bg-body">
      <Suspense fallback={<AppLoader />}>
        {routes}
        <ToastContainer
          className="top-20"
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </Suspense>
    </div>
  );
}

export default App;
